<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <p :style="alertMessageStyle" class="font-weight-bolder text-danger">
                {{ $t('exception.access_denied') }}
            </p>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'

export default {
    components: {
        mainContent
    },
    data() {
        return {
            alertMessageStyle: {
                fontSize: '20px',
            }
        }
    }
}
</script>

<style>

</style>